/**
 * Figma UX 3.0 (file key sYM6KA0VDSH7csbDy9IIfJ) — Page 1 sections and screen inventory.
 *
 * Component refs:
 * - Chat composer (guided flow): node 31-2962
 * - Edit saved task modal: node 31-470
 *   https://www.figma.com/design/sYM6KA0VDSH7csbDy9IIfJ/UX-3.0?node-id=31-470
 */
export const FIGMA_PAGES = ['Page 1', 'Page 2', 'Page 3'] as const;

export const FIGMA_SECTIONS = [
  'Operator-Home-screen',
  'New-user-Home-screen',
  'Add-device-controller-flow-novice',
  'Add-device-controller-flow-operator',
  'Add-user-flow-novice',
  'Add-user-flow-operator',
] as const;

export type FigmaSection = (typeof FIGMA_SECTIONS)[number];

export const FIGMA_ENTRY_SCREENS: Record<FigmaSection, string[]> = {
  'Operator-Home-screen': ['Home-screen_Operator_user'],
  'New-user-Home-screen': ['Home-screen_Novice_user'],
  'Add-device-controller-flow-novice': ['Home-screen_Novice_user', 'Add_device_Novice_user'],
  'Add-device-controller-flow-operator': ['Add_device_operator'],
  'Add-user-flow-novice': ['Add_user_Novice_user'],
  'Add-user-flow-operator': ['Add_user_operator'],
};

/** Exported PNG references under public/figma-screens/ */
export const FIGMA_SCREEN_ASSETS = {
  brandKit: '/figma-screens/brand-kit.png',
  dsFoundations: '/figma-screens/ds-foundations.png',
  operatorHome: ['/figma-screens/operator-home-1.png', '/figma-screens/operator-home-2.png'],
  noviceHome: ['/figma-screens/novice-home-1.png', '/figma-screens/novice-home-2.png'],
  operatorDeviceFlow: [
    '/figma-screens/operator-flow-1.png',
    '/figma-screens/operator-flow-2.png',
    '/figma-screens/operator-flow-3.png',
    '/figma-screens/operator-flow-4.png',
    '/figma-screens/operator-flow-5.png',
    '/figma-screens/operator-flow-6.png',
  ],
} as const;
